import { UI } from "../types/actions";

const initialState = {
	preloader: false,
	atBottom: false,
	scrollToZero: 0
};

export default (state = initialState, action) => {
	switch (action.type) {
		case UI.TOGGLE_PRELOADER:
			return {
				...state,
				preloader: action.payload
			};
		case UI.TOGGLE_AT_BOTTOM: {
			return {
				...state,
				atBottom: action.payload
			};
		}
		default:
			return state;
	}
};
